import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=8b0931ac&scoped=true&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "./Main.vue?vue&type=style&index=0&id=8b0931ac&prod&lang=css&"
import style1 from "./Main.vue?vue&type=style&index=1&id=8b0931ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0931ac",
  null
  
)

export default component.exports